// extracted by mini-css-extract-plugin
export default {"lightSwipeContainer":"LightSwipe_lightSwipeContainer__xPoo8","lightSwipe":"LightSwipe_lightSwipe__JwTwV","swipe":"LightSwipe_swipe__HL4qK","loop":"LightSwipe_loop__XCIpd"};